(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBundleProductTabs(root) {
      if (!root || root.dataset.bptReady === 'true') return;
      root.dataset.bptReady = 'true';

      var links = Array.prototype.slice.call(root.querySelectorAll('.bpt__tab.js-tab-link'));
      var titleEl = root.querySelector('[data-bpt-mobile-title]');
      var prevBtn = root.querySelector('[data-bpt-prev]');
      var nextBtn = root.querySelector('[data-bpt-next]');
      if (!links.length) return;

      function activeIndex() {
        var idx = links.findIndex(function (link) {
          return link.classList.contains('tab__link--active') || link.getAttribute('aria-selected') === 'true';
        });
        return idx < 0 ? 0 : idx;
      }

      function syncTitle() {
        if (!titleEl) return;
        var active = links[activeIndex()];
        if (active) titleEl.textContent = active.getAttribute('data-bpt-title') || active.textContent.trim();
      }

      function goTo(index) {
        var total = links.length;
        var next = ((index % total) + total) % total;
        links[next].click();
        syncTitle();
      }

      links.forEach(function (link) {
        link.addEventListener('click', function () {
          window.setTimeout(syncTitle, 0);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(activeIndex() - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(activeIndex() + 1);
        });
      }

      syncTitle();
    }

    function boot() {
      document.querySelectorAll('[data-bpt-root]').forEach(initBundleProductTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector('[data-bpt-root]');
      if (root) {
        root.dataset.bptReady = 'false';
        initBundleProductTabs(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-ui-component="Home Featured Reviews Section"]');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-reviews-track]');
      var controls = section.querySelector('[data-reviews-controls]');
      if (!track || !controls) return;

      var prevBtn = section.querySelector('[data-reviews-prev]');
      var nextBtn = section.querySelector('[data-reviews-next]');
      var dots = section.querySelectorAll('[data-reviews-dot]');
      var cards = track.querySelectorAll('.home-featured-reviews__card');
      if (!cards.length) return;

      function getStep() {
        if (cards.length < 2) return 0;
        return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      }

      function getActiveIndex() {
        var step = getStep();
        if (!step) return 0;
        var idx = Math.round(track.scrollLeft / step);
        return Math.max(0, Math.min(cards.length - 1, idx));
      }

      function updateDots() {
        var active = getActiveIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('home-featured-reviews__dot--active', i === active);
        });
      }

      function scrollToIndex(i) {
        var step = getStep();
        var target = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({ left: step * target, behavior: 'smooth' });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToIndex(getActiveIndex() - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToIndex(getActiveIndex() + 1);
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          scrollToIndex(i);
        });
      });

      /* CWV-06. Already coalesced to one update per frame; the missing half was
         passive. Without that flag the browser has to wait for this handler before it
         can scroll, because it cannot know in advance that preventDefault is never
         called. It never is here, so the flag costs nothing. */
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateDots();
          ticking = false;
        });
      }, { passive: true });

      updateDots();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
